import React, { useState, useCallback, useRef, useEffect } from 'react'
import { Typography } from "@mui/material";
import MyPlannerGlobalNote from './MyPlannerGlobalNote';
import GlobalSearch from '../../../components/Search/index';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { usePlannerGlobalNotes } from '../../../utils/reactQuery/plannerTodos';
import DynamicColorNote from './components/DynamicColorNote';
import { removeHtmlTagsAndEntities } from '../../../utils';
import NoteEditor from './components/NoteEditor';
import NotePopover from './components/NotePopover';
import { newFormatDate } from '../../../utils/helpers';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { putPlannerTodosNotes, deletePlannerTodosNotes } from '../../../sevices/apiPlannerTodos';
import toast from 'react-hot-toast';
import './MyPlannerHeading.scss';
import { useDispatch } from 'react-redux';
import _ from "lodash";
import { setMyPlannerSearchText } from '../../../redux/plannerFilterSlice';
import FormDialog from '../../../components/Dialog/FormDialog';


const MyPlannerHeading = React.memo(({ inputValue, setInputValue }) => {

  // Helper function to extract content before first <br> or fallback to first 150 chars
  const getTaskDisplayContent = (htmlContent) => {
    if (!htmlContent) return '';

    // Split content by paragraph tags to find the first meaningful content
    const paragraphs = htmlContent.split(/<\/p><p[^>]*>/i);
    console.log("paragraphs", htmlContent, paragraphs)
    
    for (let i = 0; i < paragraphs.length; i++) {
      const cleanedParagraph = removeHtmlTagsAndEntities(paragraphs[i]).trim();
      
      // Skip empty paragraphs and paragraphs that only contain br tags
      if (cleanedParagraph.length > 0 && cleanedParagraph !== '') {
        return cleanedParagraph.slice(0, 150);
      }
    }

    // Fallback to first 150 characters of cleaned content if no meaningful content found in paragraphs
    const fullCleanedContent = removeHtmlTagsAndEntities(htmlContent).trim();
    return fullCleanedContent.slice(0, 150);
  };
  const [seeAllNotes, setSeeAllNotes] = useState(false);
  const searchInputRef = useRef(null);
  const [isTyping, setIsTyping] = useState(false);
  const { error, globalNotes, isError, isRefetching } = usePlannerGlobalNotes();

  // Note editor state
  const [isNoteEditorOpen, setIsNoteEditorOpen] = useState(false);
  const [currentNote, setCurrentNote] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const dispatch = useDispatch();

  // State for note preview popover (inline notes)
  const [openInlineNotePreview, setOpenInlineNotePreview] = useState(false);
  const [inlineNoteAnchorEl, setInlineNoteAnchorEl] = useState(null);
  const [inlinePreviewNote, setInlinePreviewNote] = useState(null);

  // State for confirmation dialog
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  console.log("searchText ===", globalNotes)
  // const handleSearchChange = useCallback((event) => {
  //   setIsTyping(true);
  //   if (setSearchText) {
  //     setSearchText(event.target.value);
  //   }
  // }, [setSearchText]);

  // // Maintain focus when typing
  // useEffect(() => {
  //   if (isTyping && searchInputRef.current) {
  //     // Use requestAnimationFrame to ensure focus is set after render
  //     requestAnimationFrame(() => {
  //       if (searchInputRef.current) {
  //         searchInputRef.current.focus();
  //       }
  //     });
  //     // Reset typing flag after a short delay
  //     const timer = setTimeout(() => setIsTyping(false), 50);
  //     return () => clearTimeout(timer);
  //   }
  // }, [searchText, isTyping]);


  const handleSearchChange = useCallback((event) => {
    const value = event.target.value.trimStart();
    setInputValue(value);
    debouncedSearch(value);
    setSeeAllNotes(true);
  }, [setInputValue]);

  const debouncedSearch = useRef(
    _.debounce((value) => {
      dispatch(setMyPlannerSearchText(value));
    }, 300)
  ).current;

  useEffect(() => {
    return () => {
      dispatch(setMyPlannerSearchText(""));
    };
  }, []);

  // Update note mutation
  const { mutate: updateNote } = useMutation({
    mutationFn: putPlannerTodosNotes,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["globalNotes"] });
      setIsLoading(false);
      toast.success("Note updated successfully");
      setIsNoteEditorOpen(false);
      setCurrentNote(null);
    },
    onError: (error) => {
      toast.error(error?.message || "Failed to update note");
      setIsLoading(false);
    },
  });

  // Delete note mutation
  const { mutate: deleteNote } = useMutation({
    mutationFn: deletePlannerTodosNotes,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["globalNotes"] });
      setIsLoading(false);
      toast.success("Note deleted successfully");
      setIsNoteEditorOpen(false);
      setCurrentNote(null);
    },
    onError: (error) => {
      toast.error(error?.message || "Failed to delete note");
      setIsLoading(false);
    },
  });

  // Handle opening note editor
  const handleOpenNoteEditor = (note) => {
    setCurrentNote({
      id: note.id,
      title: note.title || "",
      content: note.content || "",
      color_code: note.color_code || "#FFFFA5",
      created_at: note.created_at || "",
    });
    setIsNoteEditorOpen(true);
  };

  // Handle saving note
  const handleSaveNote = () => {
    if (!currentNote || !(currentNote.content?.trim() || currentNote.title?.trim())) {
      setIsNoteEditorOpen(false);
      setCurrentNote(null);
      return;
    }

    setIsLoading(true);
    updateNote({
      id: currentNote.id,
      data: {
        content: currentNote.content,
        title: currentNote.title || "",
        color_code: currentNote.color_code || "#FFFFA5",
      },
    });
  };

  // Handle closing note editor
  const handleCloseNoteEditor = () => {
    // Auto-save the note when closing (clicking outside)
    if (currentNote && (currentNote.content?.trim() || currentNote.title?.trim())) {
      setIsLoading(true);
      updateNote({
        id: currentNote.id,
        data: {
          content: currentNote.content || "",
          title: currentNote.title || "",
          color_code: currentNote.color_code || "#FFFFA5",
        },
      });
    } else {
      // If no content, just close without saving
      setIsNoteEditorOpen(false);
      setCurrentNote(null);
    }
  };

  // Handle deleting note
  const handleDeleteNote = () => {
    if (!currentNote || !currentNote.id) {
      setIsNoteEditorOpen(false);
      setCurrentNote(null);
      return;
    }

    setIsLoading(true);
    setShowConfirmationDialog(true);
    // deleteNote(currentNote.id);
  };

  // Handle note data changes
  const handleNoteChange = (updatedNote) => {
    setCurrentNote(updatedNote);
  };

  // Handle mouse hover for inline note preview
  const handleInlineNoteMouseEnter = (event, note) => {
    setInlineNoteAnchorEl(event.currentTarget);
    setInlinePreviewNote(note);
    setOpenInlineNotePreview(true);
  };

  // Handle mouse leave for inline note preview
  const handleInlineNoteMouseLeave = () => {
    setOpenInlineNotePreview(false);
    setInlineNoteAnchorEl(null);
    setInlinePreviewNote(null);
  };

  const handleCloseConfirmationDialog = () => {
    setShowConfirmationDialog(false);
  };

  const handleConfirmAction = () => {
    // Add your confirmation action logic here
    console.log("Confirmed action");
    deleteNote(currentNote.id)
    setShowConfirmationDialog(false);
  };

  // Filter notes based on search text
  const filteredNotes = globalNotes?.data?.filter((note) => {
    if (!inputValue || inputValue.trim() === '') {
      return true; // Show all notes if no search text
    }
    
    const searchLower = inputValue.toLowerCase().trim();
    const titleMatch = note.title?.toLowerCase().includes(searchLower);
    const contentMatch = removeHtmlTagsAndEntities(note.content)?.toLowerCase().includes(searchLower);
    
    return titleMatch || contentMatch;
  }).filter((note) => !note?.todo_id) || [];

  // Get all notes for inline display
  const allInlineNotes = globalNotes?.data?.filter((note) => !note?.todo_id) || [];

  return (
    <>
      <div className="assign-to-me-header d-flex justify-content-space-between align-items-base">
        <div className="d-flex align-items-center my-planner-toggle-button">
          <Typography className="assign-to-me-title mr-2">My Planner</Typography>
          
          {/* All inline note icons */}
          <div className="inline-notes-container d-flex align-items-center">
            {allInlineNotes.map((note, index) => (
              <div
                key={note.id}
                className="inline-note-icon"
                onClick={() => handleOpenNoteEditor(note)}
                onMouseEnter={(e) => handleInlineNoteMouseEnter(e, note)}
                onMouseLeave={handleInlineNoteMouseLeave}
              >
                <DynamicColorNote fill={note.color_code} />
              </div>
            ))}
            <div className="planner-actions">
              <MyPlannerGlobalNote notes={globalNotes} isRefetching={isRefetching} />
            </div>
          </div>


          <div className='notes-toggle-button'  onClick={() => setSeeAllNotes(!seeAllNotes)} >
            <Typography className='see-all-notes-title'>{seeAllNotes ? 'Collapse Notes' : 'See All Notes'}</Typography>
            {seeAllNotes ? <KeyboardArrowUpIcon sx={{ color: 'rgba(145, 158, 171, 1)' }} /> : <KeyboardArrowDownIcon sx={{ color: 'rgba(145, 158, 171, 1)' }} />}
          </div>
        </div>

        <GlobalSearch
          ref={searchInputRef}
          placeholder={"Search..."}
          searchText={inputValue}
          handleChange={handleSearchChange} />
      </div>
      {seeAllNotes && <div className='my_task_notes_container'>
        <Typography className='my_task_notes_title'>My Notes</Typography>
        {filteredNotes.map((task) => (
          <div key={task.id} className='my_task_notes_content'>
            <div className="note-item-content">
              <Typography className='note-item-title'>{task?.title || getTaskDisplayContent(task.content)}</Typography>
              {/* <Typography className='note-item-content'>{removeHtmlTagsAndEntities(task.content)}</Typography> */}
            </div>
            <div
              className="note-icon-clickable"
              onClick={() => handleOpenNoteEditor(task)}
              style={{ cursor: 'pointer' }}
            >
              <DynamicColorNote fill={task.color_code} />
            </div>
          </div>
        ))}
      </div>}

      {/* Note Editor Dialog */}
      {isNoteEditorOpen && <NoteEditor
        open={isNoteEditorOpen}
        onClose={handleCloseNoteEditor}
        onSave={handleSaveNote}
        onDelete={handleDeleteNote}
        noteData={currentNote || {
          id: null,
          title: "",
          content: "",
          color_code: "#FFFFA5",
          created_at: "",
        }}
        onNoteChange={handleNoteChange}
        isLoading={isLoading}
        width="591px"
      />}

      {/* Inline Note Preview Popover */}
      <NotePopover
        open={openInlineNotePreview}
        anchorEl={inlineNoteAnchorEl}
        onClose={handleInlineNoteMouseLeave}
        content={inlinePreviewNote?.content || ""}
        title={inlinePreviewNote?.title || ""}
        date={newFormatDate(inlinePreviewNote?.created_at)}
        backgroundColor={inlinePreviewNote?.color_code || "#fff9c4"}
      />

      {/* Confirmation Dialog */}
      {showConfirmationDialog && (
        <FormDialog
          open={showConfirmationDialog}
          handleClose={handleCloseConfirmationDialog}
          handleSubmit={handleConfirmAction}
          buttonTxt="Delete"
          title={`Delete Note ${currentNote?.title}`}
          cancelBtn={true}
          cancelBtnTxt="Cancel"
          alignActions="center"
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2">
            Are you sure you want to delete this note?
          </Typography>
        </FormDialog>
      )}
    </>
  );
});

export default MyPlannerHeading